import KTImageInput from 'general/components/OtherKeenComponents/FileUpload/KTImageInput';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';

ImageView.propTypes = {
  name: PropTypes.string.isRequired,
  path: PropTypes.string,
  onRemove: PropTypes.func,
  fileName: PropTypes.string,
  showFileName: PropTypes.bool,
};

function ImageView(props) {
  // MARK: ---- PROPERTIES ----
  const { name, path, item, onRemove, fileName, showFileName = true } = props;
  const fileExt = Utils.getFileExt(path);
  const image = item
    ? item instanceof File ? URL.createObjectURL(item) : Utils.getFullUrl(item)
    : AppResource.icons.fileType[`icFileType${fileExt}`] ??
    AppResource.icons.fileType.icFileTypeUNKNOWN;

  return (
    <div className="d-flex flex-column gap-1">
      <KTImageInput
        name={name}
        value={image}
        aspectRatio={'16/9'}
        backgroundSize="contain"
        defaultImage={AppResource.icons.avatar.carDefault}
        additionalInputClassName="w-100 bg-white"
        disabled={true}
        editable={false}
        removable={Utils.isValid(onRemove)}
        onForceRemoveFile={onRemove}
        onPress={() => {
          Utils.openInNewTab(Utils.getFullUrl(path));
        }}
      />
      <div>
        {/* <KTTooltip text={path}>
          <span
            className="text-ellipsis-2-lines"
            style={UIHelper.buildFontStyle('500', '12px', AppColors.gray[800])}
          >
            {path}
          </span>
        </KTTooltip> */}
        {showFileName && (
          <span
            className="text-ellipsis-2-lines"
            style={UIHelper.buildFontStyle('500', '12px', AppColors.gray[800])}
          >
            {fileName ?? path}
          </span>
        )}
      </div>
    </div>
  );
}

export default ImageView;
